import { Typography } from 'shared/components/Typography';

export const SessionsRecapSubject = ({ subject }: { subject: string }) => (
  <Typography type="meta" color="black" fontWeight="semibold">
    {subject}
  </Typography>
);
